import { computed } from 'vue';
import { useStore } from '@/utils/vue-api';
import i18n from '@/assets/js/i18n';

export const SUB_MODULES = ['main_index', 'balance_sheet', 'profit_statement', 'cash_flow_statement'];

export function useFinanceCommon() {
	const store = useStore();
	const getIrFullCode = computed(() => store.getters.getIrFullCode);
	const isHKStock = computed(() => {
		return getIrFullCode.value.startsWith('hk');
	});

	const getComparisonPeriod = computed(() => {
		if (isHKStock.value) {
			return [
				{
					text: i18n.t('enterprise.finance-data.interim'),
					value: 'S1'
				},
				{
					text: i18n.t('enterprise.finance-data.annual'),
					value: 'A'
				}
			];
		}
		return [
			{
				text: i18n.t('enterprise.finance-data.first-quarter'),
				value: 'Q1'
			},
			{
				text: i18n.t('enterprise.finance-data.interim'),
				value: 'S1'
			},
			{
				text: i18n.t('enterprise.finance-data.third-quarter'),
				value: 'Q3'
			},
			{
				text: i18n.t('enterprise.finance-data.annual'),
				value: 'A'
			}
		];
	});

	// 处理数据切片的通用方法
	const sliceDataByDate = (data, lastDate) => {
		if (!data || !Array.isArray(data)) return [];
		return data.slice(0 - lastDate).map(ele => ({
			...ele,
			year: ele.year.toString()
		}));
	};

	return {
		getComparisonPeriod,
		sliceDataByDate
	};
}
